export default __webpack_public_path__ + "static/media/img2.a1f5cb7c.jpg";